<script>
  import AppContent from "../../components/Layout/AppContent.svelte";
  import AppText from "../../components/Text/AppText.svelte";
  import Spacing from "../../components/Spacing/Spacing.svelte";
  import DataTable, { Head, Body, Row, Cell } from "@smui/data-table";
  import { onMount, onDestroy } from "svelte";
  import { Router, Route, navigate } from "svelte-routing";
  import API from "../../utils/api";
  import { i18n } from "../../stores/i18n";
  import Input from "../../components/Form/Input.svelte";
  import FormField from "@smui/form-field";
  import Radio from "@smui/radio";
  import Dialog, { Content } from "@smui/dialog";
  import AppButton from "../../components/Button/AppButton.svelte";
  import { clubdeal } from "../../stores/clubdeal";
  import { autoUpdate } from "../../utils/functions/autoUpdate";
  import AppSnackbar from "../../components/Snackbar/AppSnackbar.svelte";
  import {
    REGION_LIST,
    COUNTRY_LIST,
    INSTRUMENTS_LISTS,
    PERIODICITIES_LIST,
    TYPOLOGIES_LISTS,
  } from "../../constants";
  import JSZip from "jszip";

  export let disabled;
  export let data;

  let loading = false;

  let snackSaved;
  autoUpdate(clubdeal, onMount, onDestroy, (state) => {
    snackSaved.forceOpen();
  });
  let options = [
    {
      name: "SA",
    },
    {
      name: "SAS",
    },
    {
      name: "SCA",
    },
    {
      name: "SARL",
    },
  ];

  let selected3 = data.periodicity || "monthly";

  let companyHeadquarters =
    REGION_LIST.find((el) => el.value == data.company.headquartersRegion) ||
    COUNTRY_LIST.find((el) => el.value == data.company.headquartersCountry);
  companyHeadquarters = companyHeadquarters ? companyHeadquarters.label : [];

  let instrumentValue = INSTRUMENTS_LISTS.find(
    (el) => el.value == data.instrument,
  );
  instrumentValue = instrumentValue ? instrumentValue.value : "";

  let typologyValue = TYPOLOGIES_LISTS.find((el) => el.value == data.typology);
  typologyValue = typologyValue ? typologyValue.value : "";

  const cell_style = `
  text-align:center;
  background: rgb(226, 226, 226);
  color: rgb(180, 180, 180);
  font-weight: 500;
  font-family: "Lato";
  font-weight: 700;
  `;

  let closeDataroomDialogConfirmation;
  const closeDataroom = async () => {
    closeDataroomDialogConfirmation.close();
    try {
      await API.post("clubdealAdvisorClose", {
        bondId: data.id,
      });
      navigate("/manager");
    } catch (e) {
      console.error(e);
    }
  };

  function getClubDealName(cd) {
    if (cd.name && cd.name.length) {
      return cd.name;
    }
    if (cd.company.name && cd.company.name.length) {
      return cd.company.name;
    }
    return "Inconnu";
  }
  const exportDataroomDocuments = async () => {
    try {
      loading = true;
      let docs = (await API.get("document", { bondId: data.id })).documents
      var zip = new JSZip();
      for (let doc of docs) {
        let freshDoc = await API.get("document", {
          bondId: data.id,
          id: doc.id,
        });
        let response = await fetch(freshDoc.url, { method: "GET" });
        // download file
        var newBlob = new Blob([await response.blob()], {
          type: freshDoc.contentType,
        });
        zip.file(doc.fileName, newBlob);
      }
      zip.generateAsync({ type: "blob" }).then(function (content) {
        saveAs(
          content,
          `FirmClosing_${getClubDealName(data)}.zip`
        );
      });
    } catch (e) {
      console.error(e);
    } finally {
      loading = false;
    }
  };

  const findSubscriber = (event) => {
    return data.clubDealInvestors.find((el) => el.id === event.subscriberId);
  };
  const getSubscriberName = (event) => {
    let s = findSubscriber(event);
    return s? `${s.firstName} ${s.lastName}`: $i18n("Inconnu", "Unknown");
  };
  const exportDataroomLogs = async () => {
    try {
      loading = true;
      console.log(data)
      let zip = new JSZip();
      let bom = "\ufeff";
      let csv = bom + "Date;Heure;Type d'événement;Information complémentaire;Participant\n";
      for (let evt of data.events){
        let date = new Date(evt.date);
        let eventType = "";
        if (evt.eventType == "bondCreated"){
          eventType = "Création de la dataroom";
        } else if (evt.eventType == "bondRead"){
          eventType = "Consultation de la dataroom";
        } else if (evt.eventType == "bondUpdated"){
          eventType = "Modification de la dataroom";
        } else if (evt.eventType == "documentCreated"){
          eventType = "Ajout du document";
        } else if (evt.eventType == "documentRead"){
          eventType = "Lecture du document";
        }
        let subscriber = getSubscriberName(evt);
        csv += `${date.toLocaleDateString("fr-FR")};${date.toLocaleTimeString("fr-FR")};${eventType};${evt.detail};${subscriber}\n`;
      }
      zip.file("EventLog.csv", csv);
      zip.generateAsync({ type: "blob" }).then(function (content) {
        saveAs(
          content,
          `FirmClosing_${getClubDealName(data)}_EventLog.zip`
        );
      });
    } catch (e) {
      console.error(e);
    } finally {
      loading = false;
    }
  };
  
</script>

<Spacing y="16" />
<AppContent type="advisor" loading={loading}>
  <section>
    <AppText color="blue" weight="900" size="large"
      >{$i18n("Société", "Company")}</AppText
    >
    <Spacing y="8" />
    <main>
      <Spacing divider block />
    </main>
  </section>
  <div>
    <!-- <aside> -->
    <Input
      label={$i18n("Raison sociale", "Company name")}
      bind:value={$clubdeal.company.name}
      crop
      disabled
    />
    <!-- <Input
        label={$i18n("Siren", "Siren")}
        bind:value={$clubdeal.company.siret}
        crop
        {disabled}
      /> -->
    <!-- </aside> -->
    <Spacing y="12" />
    <AppText weight="700">{$i18n("Forme juridique", "Legal form")}:</AppText>
    <Spacing y="4" />
    {#each options as option}
      <FormField>
        <Radio
          color="primary"
          bind:group={$clubdeal.company.legalForm}
          value={option.name}
          disabled
        />
        <span style="margin-right:4px;" slot="label">{option.name}</span>
      </FormField>
    {/each}
    <Spacing y="12" />
    <Input
      label={$i18n("Lieu du siège social", "Location of the head office")}
      value={$i18n(companyHeadquarters)}
      crop
      {disabled}
    />
  </div>
  <section>
    <AppText weight="900" color="blue" size="large">
      {$i18n(
        "Caractéristiques de l'opération",
        "Characteristics of the operation",
      )}
    </AppText>
    <Spacing y="8" />
    <main>
      <Spacing divider block />
    </main>
  </section>
  <div>
    <aside>
      <Input
        label={$i18n("Montant", "Amount")}
        value={data.amount / 1e6}
        crop
        suffix="M€"
        on:change={(customEvent) => {
          $clubdeal.amount = customEvent.detail.target.value * 1e6;
        }}
      />
      <Input
        label={$i18n("Taux", "Rate")}
        value={data.rate}
        crop
        suffix="%"
        on:change={(customEvent) => {
          $clubdeal.rate = customEvent.detail.target.value;
        }}
      />
    </aside>
    <Spacing y="12" />
    <Input
      label={$i18n("Durée", "Duration")}
      bind:value={$clubdeal.maturity}
      crop
      suffix={$i18n("mois", "months")}
    />
    <Spacing y="12" />
    <AppText weight="700"
      >{$i18n("Typologie de l'opération", "Typology of the operation")} :</AppText
    >
    <Spacing y="4" />
    {#each TYPOLOGIES_LISTS as typology}
      <FormField>
        <Radio bind:group={$clubdeal.typology} value={typology.value} />
        <span slot="label">{$i18n(...typology.label)}</span>
      </FormField>
    {/each}

    <!-- <Spacing y="12" />
        <AppText weight="700"
          >{$i18n("Typologie de financement", "Type of financing")} :</AppText
        >
        <Spacing y="4" />
        {#each INSTRUMENTS_LISTS as instrument}
          <FormField>
            <Radio
              color="primary"
              bind:group={instrumentValue}
              value={instrument.value}
              {disabled}
            />
            <span style="margin-right:4px;" slot="label"
              >{$i18n(...instrument.label)}</span
            >
          </FormField>
        {/each}
        <Spacing y="12" />
        <AppText weight="700"
          >{$i18n(
            "Fréquence des coupons (si applicable)",
            "Coupon frequency (if applicable)"
          )}:</AppText
        >
        <Spacing y="4" />
        {#each PERIODICITIES_LIST as frequency}
          <FormField>
            <Radio
              {disabled}
              color="primary"
              bind:group={selected3}
              value={frequency.value}
            />
            <span style="margin-right:4px;" slot="label"
              >{$i18n(...frequency.name)}</span
            >
          </FormField>
        {/each} -->
  </div>

  <Dialog
    style="z-index:1999; width: 100%"
    bind:this={closeDataroomDialogConfirmation}
  >
    <Content>
      <AppText color="blue" weight="900" size="large"
        >{$i18n("Confirmation", "Confirmation")}</AppText
      >
      <Spacing y="8" />
      <AppText
        >{$i18n(
          "Êtes-vous sûr de vouloir clôturer cette dataroom ?",
          "Are you sure you want to close this dataroom?",
        )}</AppText
      >
      <Spacing y="8" />
      <AppButton block on:click={closeDataroom}
        >{$i18n("Clôturer la dataroom", "Close this dataroom")}</AppButton
      >
    </Content>
  </Dialog>

  <section>
    <AppText weight="900" color="blue" size="large">
      {$i18n("Administration", "Administration")}
    </AppText>
    <main>
      <Spacing divider block />
    </main>
  </section>
  <div class="admin">
    <div>
      <div>
        <AppButton on:click={() => exportDataroomDocuments()}
          >{$i18n(
            "Télécharger tous les documents",
            "Download all the documents",
          )}</AppButton
        >
      </div>

      <div>
        <AppButton
          on:click={() => exportDataroomLogs()}
          style="flex: 1 1 auto"
          >{$i18n(
            "Télécharger le journal des événements",
            "Download the event log",
          )}</AppButton
        >
      </div>
    </div>

    <Spacing y="18" />

    <AppButton
      block
      color="alert"
      on:click={() => closeDataroomDialogConfirmation.open()}
      >{$i18n("Clôturer la dataroom", "Close the dataroom")}</AppButton
    >
  </div>

  <AppSnackbar
    bind:value={snackSaved}
    labelText={$i18n(
      "Vos informations ont bien été enregistrées",
      "Your information has been saved",
    )}
  />
</AppContent>

<style lang="scss">
  div.admin {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    position: relative;
    margin-left: 8px;
    margin-top: 3px;
    div {
      flex: 100%;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      margin: 0;
      padding: 0;
      div {
        flex: 50%;
        margin-left: 8px;
        margin-top: 3px;
      }
    }
  }
  section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    position: relative;
    main {
      flex: 1 1 auto;
      margin-left: 8px;
      margin-top: 3px;
    }
  }
  div {
    padding: 24px;
    margin: 12px 0;
  }
  aside {
    display: grid;
    gap: 16px;
    /* grid-template-columns: repeat(1, 1fr); */
    @include respond-to("sm") {
      grid-template-columns: repeat(2, 1fr);
    }
  }
</style>
